import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { trackPageView, trackCategoryView } from '../utils/analytics';
import {Theme} from "../config/theme";

const HomeContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Content = styled.div`
  flex: 1;
`;

const Title = styled.h1`
  text-align: center;
  margin-bottom: 2rem;
  color: ${Theme.colors.main};
`;

const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  padding: 1rem;
`;

const CategoryCard = styled.div`
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  cursor: pointer;

  &:hover {
    transform: translateY(-4px);
  }
`;

const CategoryImage = styled.img`
  //width: 100%;
  //height: 200px;
  //object-fit: cover;
  //  aspect-ratio: 1;
    height: 100%;
    object-fit: cover;
    aspect-ratio: 1 / 1;
    max-height: 200px;
    margin: auto;
    margin-top: 10px;
    display: block;
`;

const CategoryTitle = styled.h2`
  padding: 1rem;
  text-align: center;
  color: ${Theme.colors.main};
  font-size: 1.2rem;
`;

const Footer = styled.div`
  text-align: center;
  padding: 2rem 1rem;
  color: ${Theme.colors.footer.text};
`;

const FooterLink = styled.a`
  color: ${Theme.colors.footer.text};
  text-decoration: none;
  font-size: 0.9rem;
  
  &:hover {
    color: ${Theme.colors.footer.textHoover};
    text-decoration: underline;
  }
`;

const Home: React.FC = () => {
  const navigate = useNavigate();
  const categories = useSelector((state: RootState) => state.categories.categories);

  useEffect(() => {
    trackPageView('Home', {
      total_categories: categories.length
    });
  }, [categories.length]);

  const handleCategoryClick = (categoryId: string) => {
    trackCategoryView(categoryId);
    navigate(`/category/${categoryId}`);
  };

          return (
      <HomeContainer>
        <Content>
          <Title>Play. Capture. Share.</Title>
          <CategoryGrid>
            {categories.map((category) => (
              <CategoryCard
                key={category.id}
                onClick={() => handleCategoryClick(category.id)}
              >
                <CategoryImage src={category.thumbnail} alt={category.name} />
                <CategoryTitle>{category.name}</CategoryTitle>
              </CategoryCard>
            ))}
          </CategoryGrid>
        </Content>
        <Footer>
          <FooterLink href="/privacy-policy">Privacy Policy</FooterLink>
        </Footer>
      </HomeContainer>
    );
};

export default Home; 